<script setup>
import { onMounted } from "vue";
import IconToastCheck from "@/assets/icons/IconToastCheck.vue";
import IconToastCross from "@/assets/icons/IconToastCross.vue";
import IconToastAlert from "@/assets/icons/IconToastAlert.vue";
import IconToastMessage from "@/assets/icons/IconToastMessage.vue";

const props = defineProps({
  notification: {
    type: Object,
    required: true,
    validator: (value) => {
      return value && typeof value === "object" && 
             value.id !== undefined && 
             value.message !== undefined &&
             value.type !== undefined;
    }
  },
  autoClose: {
    type: Boolean,
    default: true
  }
});

const emit = defineEmits(["close"]);

onMounted(() => {
  if (props.autoClose && props.notification.lifeTime > 0) {
    setTimeout(() => {
      emit("close", props.notification.id);
    }, props.notification.lifeTime);
  }
}); 

const handleClose = () => {
  emit("close", props.notification.id);
};
</script>

<template>
  <div
    class="notification-item"
    @click="handleClose"
  >
    <div class="notification-item__icon">
      <IconToastCheck
        v-if="notification.type === 'success'"
        name="accept-icon"
        width="34px"
        height="34px"
      />
      <IconToastCross
        v-if="notification.type === 'error'"
        name="warning-icon"
        width="34px"
        height="34px"
      />
      <IconToastAlert
        v-if="notification.type === 'warning'"
        name="warning-icon"
        width="34px"
        height="34px"
      />
      <IconToastMessage
        v-if="notification.type === 'info'"
        name="info-icon"
        width="34px"
        height="34px"
      />
    </div>

    <div class="notification-item__content">
      <div class="notification-item__message">
        {{ notification.message }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.notification-item {
  font-size: 22px;
  font-weight: 400;
  display: flex;
  align-items: center;
  max-width: 580px;
  padding: 20px;
  cursor: pointer;
  user-select: none;
  color: #FFFFFF;
  border-radius: 20px;
  background: #1F9AFF;
  gap: 10px;

  &__message {
    font-size: 22px;
    font-weight: 400;
    display: flex;
    flex-wrap: wrap;
    //word-break: break-all;
  }
}
</style>